export default {
  labels: {
    card: 'Carta di credito',
    bank_account: 'Conto bancario',
  },
  alerts: {
    payments_not_configured:
      'I pagamenti non sono ancora configurati. Contatta il tuo fornitore per abilitarli, poi torna a questo passaggio.',
  },
  buttons: {
    change_payment_method: 'Cambia metodo di pagamento',
    save_payment_info: 'Salva informazioni di pagamento',
  },
  toasts: {
    failed_to_init_payment_setup: 'Impossibile avviare la configurazione del pagamento, ricarica la pagina',
    successfully_saved_payment_method: 'Informazioni di pagamento salvate',
  },
};
